import { render, staticRenderFns } from "./HIRadio.vue?vue&type=template&id=6b06cc1a&"
import script from "./HIRadio.vue?vue&type=script&lang=js&"
export * from "./HIRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports